export class AssetLoader {
  static cache: Map<string, ImageBitmap> = new Map();
  static async img(url: string): Promise<ImageBitmap> {
    const existing = this.cache.get(url);
    if (existing) return existing;
    const resp = await fetch(url);
    const newImage = await window.createImageBitmap(await resp.blob());
    this.cache.set(url, newImage);
    return newImage;
  }
}
